import { jsx, Fragment } from "react/jsx-runtime";
import { ConciergePartItem } from "./ConciergePartItem.js";
function ConciergeMessagePart({
  parts,
  onProductClick,
  isStreaming,
  pdpStacklineSku,
  isOnChatWidget,
  apiBaseUrl,
  onSignIn
}) {
  if (!parts || parts.length === 0) return null;
  const normalizedParts = parts;
  return /* @__PURE__ */ jsx(Fragment, { children: normalizedParts.map((part, index) => /* @__PURE__ */ jsx(
    ConciergePartItem,
    {
      part,
      allParts: normalizedParts,
      onProductClick,
      isStreaming,
      pdpStacklineSku,
      isOnChatWidget,
      apiBaseUrl,
      onSignIn
    },
    `${part.type}-${index}`
  )) });
}
export {
  ConciergeMessagePart
};
//# sourceMappingURL=index.js.map
